// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Login from "./Login";
import Home from "./Home";
import Regi from "./pages/Regi";
import List from "./pages/List";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");

    if (token && user) {
      try {
        JSON.parse(user); // Validate user data
        setIsAuthenticated(true);
      } catch (error) {
        console.error("Invalid user data:", error);
        localStorage.clear();
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }

    setIsLoading(false);
  }, []);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

// Separate component to handle routing logic
function AppContent() {
  const location = useLocation();
  
  // Redirect from /home to / if user tries to access /home directly
  useEffect(() => {
    if (location.pathname === "/home") {
      // This will trigger a redirect in the Routes below
      // or you can use window.history.replaceState
      window.history.replaceState(null, "", "/");
    }
  }, [location]);

  return (
    <Routes>
      {/* Login always exists */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* Only one route for home page - at root */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />

      {/* Redirect /home to / */}
      <Route path="/home" element={<Navigate to="/" replace />} />

      {/* Protected routes */}
      <Route
        path="/register"
        element={
          <PrivateRoute>
            <Regi />
          </PrivateRoute>
        }
      />
      <Route
        path="/list"
        element={
          <PrivateRoute>
            <List />
          </PrivateRoute>
        }
      />

      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function PublicRoute({ children }) {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  
  if (token && user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

export default App;